module.exports = __webpack_public_path__ + "img/education.2a12da1d.png";